/**
 * CUSTOM: Cart Shipping Display
 * Zeigt im Kaching-Cart-Drawer die echten Versandkosten an, wenn der Kunde aus DE kommt.
 * Quelle: /cart/shipping_rates.json (Shopify-Versandprofile, gewichtsbasiert).
 */
(function () {
  'use strict';

  var cfg = window.RoughCartShippingConfig || {};
  if (!cfg.enabled) return;

  var TARGET = cfg.targetCountry || 'DE';
  var ZIP = (cfg.defaultZip || '10115').toString().trim();
  var TEMPLATE = cfg.displayTemplate || '{price}';
  var FREE_TEXT = cfg.freeShippingText || 'FREE SHIPPING';
  var CURRENCY = cfg.currencySymbol || 'EUR';
  var CACHE_KEY = 'rough_cart_country_v1';
  var CACHE_MS = (cfg.cacheHours || 24) * 3600 * 1000;
  var DEBUG = !!cfg.debug;
  var INCLUDE_SHIPPING_IN_SUBTOTAL = !!cfg.includeShippingInSubtotal;
  var SUBTOTAL_LABEL_OVERRIDE = (cfg.subtotalLabelOverride || '').toString();

  var CURRENCY_SYMBOLS = { EUR: '€', USD: '$', GBP: '£' };
  var SYMBOL = CURRENCY_SYMBOLS[CURRENCY] || '€';

  function log() {
    if (!DEBUG) return;
    var args = ['[CartShipping]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  /* ----------------------------- Country detection ----------------------------- */

  function readCachedCountry() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.expires || data.expires < Date.now()) return null;
      return data.country || null;
    } catch (e) { return null; }
  }

  function writeCachedCountry(country) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        country: country,
        expires: Date.now() + CACHE_MS
      }));
    } catch (e) {}
  }

  function fetchCountryFromIp() {
    return fetch('https://ipapi.co/country/', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (txt) {
        if (!txt) return null;
        var c = txt.trim().toUpperCase();
        return /^[A-Z]{2}$/.test(c) ? c : null;
      })
      .catch(function () { return null; });
  }

  function detectCountry() {
    var cached = readCachedCountry();
    if (cached) {
      log('country (cache):', cached);
      return Promise.resolve(cached);
    }

    var fromLiquid = (cfg.shopCountryFromLiquid || '').toString().trim().toUpperCase();
    if (/^[A-Z]{2}$/.test(fromLiquid)) {
      log('country (liquid):', fromLiquid);
      writeCachedCountry(fromLiquid);
      return Promise.resolve(fromLiquid);
    }

    return fetchCountryFromIp().then(function (c) {
      if (c) {
        log('country (ip):', c);
        writeCachedCountry(c);
      } else {
        log('country detection failed');
      }
      return c;
    });
  }

  /* ----------------------------- Shipping rates ----------------------------- */

  var lastCartHash = null;
  var lastRate = null;
  var lastCart = null;
  var inFlight = null;

  function getCartHash() {
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        lastCart = cart;
        if (!cart || !cart.items || cart.items.length === 0) return { hash: 'empty', cart: cart };
        var hash = cart.items.map(function (i) { return i.id + 'x' + i.quantity; }).join('|') + ':' + cart.total_price;
        return { hash: hash, cart: cart };
      })
      .catch(function () { return null; });
  }

  function fetchShippingRate() {
    if (inFlight) return inFlight;

    inFlight = getCartHash().then(function (info) {
      if (!info || info.hash === 'empty') {
        lastRate = null;
        lastCartHash = 'empty';
        return null;
      }
      if (info.hash === lastCartHash && lastRate !== null) {
        return lastRate;
      }
      var requiresShipping = info.cart && info.cart.items && info.cart.items.some(function (it) { return it.requires_shipping; });
      if (!requiresShipping) {
        lastRate = null;
        lastCartHash = info.hash;
        return null;
      }

      var url = '/cart/shipping_rates.json'
        + '?shipping_address[zip]=' + encodeURIComponent(ZIP)
        + '&shipping_address[country]=' + encodeURIComponent(TARGET);

      return fetch(url, { cache: 'no-store' })
        .then(function (r) {
          if (!r.ok) {
            log('shipping_rates HTTP ' + r.status);
            return null;
          }
          return r.json();
        })
        .then(function (data) {
          if (!data || !data.shipping_rates || data.shipping_rates.length === 0) {
            log('no rates returned');
            lastRate = null;
            lastCartHash = info.hash;
            return null;
          }
          var rates = data.shipping_rates.map(function (r) {
            return { name: r.name, price: parseFloat(r.price) };
          }).sort(function (a, b) { return a.price - b.price; });
          lastRate = rates[0];
          lastCartHash = info.hash;
          log('rate:', lastRate);
          return lastRate;
        })
        .catch(function (err) {
          log('shipping_rates error:', err);
          return null;
        });
    }).then(function (res) {
      inFlight = null;
      return res;
    }, function (err) {
      inFlight = null;
      throw err;
    });

    return inFlight;
  }

  /* ----------------------------- DOM injection ----------------------------- */

  function formatPrice(amount) {
    if (amount === 0) return FREE_TEXT;
    return SYMBOL + amount.toFixed(2);
  }

  function isFreeShippingReached() {
    var bar = document.querySelector('.kaching-cart__tiered-promotions-bar-progress-fill');
    if (!bar) return false;
    var pct = bar.getAttribute('data-progress-percentage');
    return pct === '100';
  }

  function getTooltipTitle() {
    return document.querySelector('.kaching-cart__tiered-promotions-bar-icon-tooltip-title');
  }

  function getSubtotalContainer() {
    return document.querySelector('.kaching-cart__subtotal');
  }

  var renderInProgress = false;

  function render() {
    if (renderInProgress) return;
    var tooltipSpan = getTooltipTitle();
    var subtotalContainer = getSubtotalContainer();
    if (!tooltipSpan && !subtotalContainer) return;

    renderInProgress = true;

    if (isFreeShippingReached()) {
      if (tooltipSpan) setSpanText(tooltipSpan, FREE_TEXT);
      if (INCLUDE_SHIPPING_IN_SUBTOTAL && subtotalContainer) updateSubtotal(subtotalContainer, 0);
      renderInProgress = false;
      return;
    }

    fetchShippingRate().then(function (rate) {
      var tooltip = getTooltipTitle();
      if (tooltip) {
        if (!rate) {
          setSpanText(tooltip, '');
        } else {
          setSpanText(tooltip, TEMPLATE.replace('{price}', formatPrice(rate.price)));
        }
      }

      if (INCLUDE_SHIPPING_IN_SUBTOTAL) {
        var sub = getSubtotalContainer();
        if (sub) {
          var shippingPrice = rate ? rate.price : 0;
          updateSubtotal(sub, shippingPrice);
        }
      }

      renderInProgress = false;
    }).catch(function () { renderInProgress = false; });
  }

  function setSpanText(span, text) {
    if (span.textContent === text) return;
    span.textContent = text;
  }

  function updateSubtotal(container, shippingPrice) {
    if (!lastCart || typeof lastCart.total_price !== 'number') return;
    var itemsTotalCents = lastCart.total_price;
    var shippingCents = Math.round((shippingPrice || 0) * 100);
    var newTotalCents = itemsTotalCents + shippingCents;
    var newTotal = newTotalCents / 100;

    var valueSpan = container.querySelector('span');
    if (valueSpan) {
      var newValue = SYMBOL + newTotal.toFixed(2);
      if (valueSpan.textContent !== newValue) {
        valueSpan.textContent = newValue;
      }
    }

    if (SUBTOTAL_LABEL_OVERRIDE) {
      for (var i = 0; i < container.childNodes.length; i++) {
        var node = container.childNodes[i];
        if (node.nodeType === Node.TEXT_NODE && node.textContent && node.textContent.trim().length > 0) {
          if (node.textContent.trim() !== SUBTOTAL_LABEL_OVERRIDE) {
            node.textContent = SUBTOTAL_LABEL_OVERRIDE + ' ';
          }
          break;
        }
      }
    }
  }

  /* ----------------------------- Init / observer ----------------------------- */

  function init() {
    detectCountry().then(function (country) {
      if (!country) {
        log('no country detected, abort');
        return;
      }
      if (country !== TARGET) {
        log('country ' + country + ' != target ' + TARGET + ', abort');
        return;
      }

      log('active for ' + TARGET);

      // Observer auf body — fängt das Erscheinen / Re-Rendering des Drawers
      var observer = new MutationObserver(function () {
        if (document.querySelector('kaching-cart-drawer')) {
          render();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });

      // Cart-Updates triggern Re-Render
      ['cart:updated', 'cart:refresh', 'kaching:cart:updated'].forEach(function (ev) {
        document.addEventListener(ev, function () { setTimeout(render, 200); });
      });

      // Fetch-Hook für /cart/add /cart/change /cart/update
      var origFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || '';
        var promise = origFetch.apply(this, args);
        if (/\/cart\/(add|change|update|clear)/i.test(url)) {
          promise.then(function () { setTimeout(render, 250); });
        }
        return promise;
      };

      render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
